<nimbus-filter-summary-button
  cdkOverlayOrigin
  #origin="cdkOverlayOrigin"
  [summary]="summary"
  [filterName]="filter.name"
  [disabled]="disabled"
  [isValueEmpty]="isValueEmpty"
  (summaryClick)="onSummaryClick()"
  (removeFilter)="onRemoveFilter()"
></nimbus-filter-summary-button>

<ng-template
  cdkConnectedOverlay
  cdkConnectedOverlayPanelClass="nimbus-filter-text-connected-overlay"
  [cdkConnectedOverlayHasBackdrop]="false"
  [cdkConnectedOverlayOrigin]="origin"
  [cdkConnectedOverlayPositions]="cdkConnectedPositions"
  [cdkConnectedOverlayScrollStrategy]="scrollStrategy"
  [cdkConnectedOverlayOpen]="isOpen$ | async"
  (detach)="onDetach()"
  (overlayOutsideClick)="onOutsideClick($event)"
>
  <div class="nimbus-tooltip-complex tooltip-content">
    <nimbus-filter-text-input
      #textInput
      [initialFilterValue]="filterValue"
      [focusable]="false"
      (valueChanged)="onValueChanged()"
    ></nimbus-filter-text-input>
  </div>
</ng-template>
